import type { SVGProps } from 'react';

const SvgSignalCellularAlt1Bar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M5 14h3v6H5z" />
  </svg>
);
export default SvgSignalCellularAlt1Bar;
